import { createSingleQueryParamHook } from '@confluence/route-manager/entry-points/RouteState.ts';

const useFocusedCommentIdQueryParam = createSingleQueryParamHook('focusedCommentId');
const useReplyToCommentIdQueryParam = createSingleQueryParamHook('replyToComment');

/**
 * Hook to get comment link information from query parameters
 * @returns The comment link string value based on query parameters
 */
export const useGetCommentLinkType = (): string | undefined => {
	const focusedCommentId = useFocusedCommentIdQueryParam();
	const replyToCommentId = useReplyToCommentIdQueryParam();

	if (focusedCommentId) {
		return 'isFocusedComment';
	} else if (replyToCommentId) {
		return 'isReplyToComment';
	}

	return undefined;
};
